import { render, staticRenderFns } from "./LostItemDetail.vue?vue&type=template&id=5e5766ef&"
import script from "./LostItemDetail.vue?vue&type=script&lang=js&"
export * from "./LostItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./LostItemDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports